module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_23.f49f9752.pdf";